import Section from "../Section"
import styles from "./LogoGrid.module.scss"
import Image from "../Image"
import cx from "classnames"

const LogoGrid = ({ data }) => {
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    logos,
    variant,
  } = data

  const sizeVariant = variant?.value || "default"

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div
        className={cx(styles.logoGrid, {
          [styles.sizeDefault]: sizeVariant === "default",
          [styles.sizeLarge]: sizeVariant === "large",
        })}
      >
        {logos?.length > 0 &&
          logos.map((logo, i) => (
            <div key={i} className={styles.logo}>
              <Image
                alt={logo.alt}
                src={logo.permalink}
                responsive="true"
                width={logo.width}
                height={logo.height}
              />
            </div>
          ))}
      </div>
    </Section>
  )
}

export default LogoGrid
